import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
const faqs = [{
  q: '¿Sirve si recién me enteré o si ya pasó un tiempo?',
  a: 'Es más efectivo cuanto antes lo aplicás, pero funciona en cualquier momento. Si recién lo descubriste, el Día 1 va a frenar los errores más peligrosos. Si ya pasó tiempo, los tomos del Día 3 en adelante te van a dar la claridad que todavía no encontraste.'
}, {
  q: '¿Tengo que hablarle sí o sí a mi pareja?',
  a: 'No. El manual te prepara para la confrontación pero no te obliga. Primero trabajamos tu estado mental y tu estrategia. La conversación viene cuando vos estés listo/a, no antes.'
}, {
  q: '¿Esto reemplaza a un psicólogo o terapeuta?',
  a: 'No reemplaza la terapia profesional, pero hace algo que la terapia sola no puede hacer: te da un protocolo de acción inmediata para los primeros 7 días, cuando más lo necesitás y cuando un turno con un profesional puede tardar semanas.'
}, {
  q: '¿Me protege de cometer errores impulsivos?',
  a: 'Sí. Ese es exactamente el objetivo del Día 1 y el Bono de Protocolo Cero Errores. Están diseñados específicamente para frenar las reacciones que después son muy difíciles de revertir.'
}, {
  q: '¿Qué pasa si descubro que no es una infidelidad?',
  a: 'El manual también te sirve. Los tomos de Gaslighting y Detección del Engaño te ayudan a distinguir si hay una infidelidad real o si hay otro problema de fondo que necesita otro tipo de abordaje.'
}];
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section aria-label="Preguntas frecuentes" className="bg-ink" data-id="element-53" data-mp="rzkuglaphaxu">
      <div className="mx-auto max-w-3xl px-5 py-12" data-id="element-54" data-mp="rx869qecu4cc">
        <h2 className="text-center font-display text-3xl font-black text-white sm:text-4xl" data-id="element-55" data-mp="wyxih9dbco20">
          ❓ Lo que más nos preguntan
        </h2>
        <div className="mt-10 divide-y divide-white/10 overflow-hidden rounded-2xl border border-white/10 bg-ink-2" data-id="element-56" data-mp="j0qv4n5zq6gl">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} data-id="element-57" data-mp="2kw6pu813u2bo" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left transition-colors hover:bg-white/[0.03] focus:outline-none focus-visible:bg-white/[0.05]" data-id="element-58" data-mp="2kuvmg9bkmwl3">
                  <span className="text-sm font-bold text-white sm:text-base" data-id="element-59" data-mp="33memq8e7nwjf">{f.q}</span>
                  {isOpen ? <MinusIcon className="h-5 w-5 shrink-0 text-rojo-soft" data-id="element-60" data-mp="2ymjxsadzxh10" /> : <PlusIcon className="h-5 w-5 shrink-0 text-plata" data-id="element-61" data-mp="2umhuxxwiyhk5" />}
                </button>
                <div className="grid transition-all duration-300 ease-in-out" style={{
              gridTemplateRows: isOpen ? '1fr' : '0fr'
            }} data-id="element-62" data-mp="1n97srw6i2sd9">
                  <div className="overflow-hidden" data-id="element-63" data-mp="3uuposuwmluho">
                    <p className="px-6 pb-5 text-sm leading-relaxed text-white/65" data-id="element-64" data-mp="3urtstc4c9fvv">{f.a}</p>
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}